import { render, staticRenderFns } from "./Sanjiaoxing.vue?vue&type=template&id=02be726a&scoped=true&"
import script from "./Sanjiaoxing.vue?vue&type=script&lang=js&"
export * from "./Sanjiaoxing.vue?vue&type=script&lang=js&"
import style0 from "./Sanjiaoxing.vue?vue&type=style&index=0&id=02be726a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be726a",
  null
  
)

export default component.exports